import React from 'react';
import ContactCarForm from './ContactCarForm';
import { url } from '../../../config';
import GoBackButton from '../Common/GoBackButton';
import axios from 'axios';
import NextSteps from '../Common/NextSteps';
import ConfirmMessage from '../Common/ConfirmMessage';
import Experts from '../Common/Experts';
import s from './ContactCar.scss';
import { isValidCharacter } from '../../../utils';
import imageExpert from '../../../assets/images/1366-gonzalo.svg';



class ContactCar extends React.Component {

    state = {
        phone: '',
        email: '',
        sendInfo: false,
        agency: '',
        errors: {
            email: '',
            phone: '', 
        },
    }

    handleChange = (e) =>{
        let name = e.target.name;
        let value = e.target.value;
        if(isValidCharacter(name, value)){
            this.setState({
                [name]: value,
            });
        }
    }

    submitUserInfo = () =>{
        const { phone, email, agency } = this.state;

        axios.post(`/api/v3/contact/`,
        {   code: "CP-PA",
            phone: phone,
            email: email,
            agency: agency,
            application: this.props.application_id && this.props.application_id,
        },)
        .then((response)=> {
            this.setState({
                agency: '',
                phone: '',
                email: '',
                sendInfo: true,
            });
        })
        .catch(({ response }) => {
            const errors = {};
            Object.keys(response.data).forEach(field => {
                errors[field] = response.data[field];
            });
            this.setState({
                errors: errors,
            });
        });   
    }
    render(){
        const { is_staff, apptype, } = this.props;
        const { phone, email, agency, errors, sendInfo } = this.state;
    
        return (
            <div>
                <div className={s.container}>
                    <div className={s.formContainer}>
                        <div className={s.goBack}><GoBackButton children={'Volver'} link={url('propuesta',apptype)} /></div>
                        <div className={s.formWraper}>
                            <div className={s.formCard}>
                                {(sendInfo)
                                        ? <ConfirmMessage title='La solicitud fue recibida con éxito.' message='En un plazo menor a 24hs nos estaremos comunicando con vos. Cualquier consulta no dudes en contactarnos.' children={true}/>
                                        : !is_staff && <ContactCarForm phone={phone} email={email} agency={agency} errors={errors} handleChange={this.handleChange} submitUserInfo={this.submitUserInfo}/>
                                    }
                            </div>
                        </div>
                        <NextSteps title='Próximos pasos:' step1='Analizamos la solicitud y te damos la aprobación' step2='Nos enviás la documentación respaldatoria' step3='¡Recibís el dinero apenas se inscribe la prenda!' textEnd={`Te enviaremos la información junto con la aprobación del crédito a tu email.`}/>
                    </div>
                </div>
                <div className={s.expertsWraper}>
                    <Experts imageExpert={imageExpert}/>
                </div>
            </div>
        )      
    }
}
export default ContactCar;
